<!-- Mensagens modal
exemplo com uso de event hub: https://laracasts.com/discuss/channels/vue/dynamic-modal-content-with-vuejs?page=1
https://github.com/hjkcai/vue-modal-dialogs

parametros:
code => codigo da mensagem cadastrada no dicionario de dados

utilização:
        <md-message v-if="showMessage" 
            code="closeform" 
            @close="handleCloseMessage()" 
            @confirm="handleConfirmMessage()">
        </md-message>

        <md-message v-if="showMessage" 
            type="" 
            title=""
            message=""
            help=""
            @close="handleCloseMessage()" 
            @confirm="handleConfirmMessage()">
        </md-message>

eventos:
confirm => botao confirma
close => botao fechar

-->

<script type="text/babel">
import { apiORDS, apiORDSpost, apiDownloadPDF, apiEmailPDF } from '../shared/api-functions'
import formField from './form-field.vue'
  export default {
  components: { formField },
    props: {
      code: {type: String, required: false},
      kind: {type: String, required: false},
      message: {type: String, required: false},
      title: {type: String, required: false},
      help: {type: String, required: false},
      visible: {type: Boolean, required: false},
      adminPass:{type: Boolean, required: false}
    },
    data () {
      return {
        vTitle: '',
        vMessage: '',
        vHelp: '',
        vClass: '',
        btnConfirmText: 'Confirmar',
        btnCancelText: 'Fechar',
        btnClass: 'nb-btdef',
        btnConfirm: true,
        btnCancel: true,
        metamessage: this.$store.getters.getEntities.messages,
        msg: {},
        senha: ''
      }
    },
    created () {
      if (this.code) {
        if (this.code == 'closeform') {
          this.btnConfirmText = 'Sim'
          this.btnCancelText = 'Não'
          this.vTitle = 'Atenção'
          this.vMessage = 'Deseja realmente sair desta tela????'
          jQuery(this.$refs.btnConfirm).focus()
        } else
        if (this.metamessage[this.code]) {
          this.msg = this.metamessage[this.code]
          this.vTitle = this.msg.title
          this.vMessage = this.msg.text
          this.vHelp = this.msg.help
        } else {
          this.vTitle = 'Mensagem não encontrada no metadata: ' + this.code
        }
      } else {
        this.vTitle = this.title
        this.vMessage = this.message
        if (this.help) {
          this.vHelp = this.help
        }
      }
      if (this.kind) {
        if (this.kind == 'delete') {
          this.btnClass = 'btn-danger'
          jQuery(this.$refs.btnClose).focus()
        } else
        if (this.kind == 'cancel') {
          this.btnClass = 'btn-danger'
          jQuery(this.$refs.btnClose).focus()
        } else
        if (this.kind == 'error') {
          this.btnClass = 'btn-danger'
          this.btnConfirm = false
          this.btnCancelText = 'OK'
          jQuery(this.$refs.btnClose).focus()
        } else
        if (this.kind == 'warning') {
          this.btnClass = 'btn-warning'
          this.btnConfirm = false
          this.btnCancelText = 'OK'
          jQuery(this.$refs.btnClose).focus()
        }
      }
      console.log(this.kind)
      console.log(this.title)
  
      this.$nextTick(function() {
        this.$refs.senha.focus()
        window.addEventListener('keyup', this.handleKeyupEvent)
      })
    },
    mounted (){
      

    },
    methods: {
         handleKeyupEvent(event){ 
          var self = this;
          if (event.keyCode === 13 && this.senha) {
            // Fecha a modal ao pressionar ENTER
             self.handleConfirmButton();
          }

          if(event.keyCode == 27) {
            // Aciona o método ao pressionar ESC
             self.handleCloseButton();
        }     
      },
      handleCloseButton () {
        
        this.visible = false
        this.$emit('close')
        window.removeEventListener('keyup', this.handleKeyupEvent)
        
      },
      async handleConfirmButton () {

        if(this.adminPass){
          if(!this.senha||this.senha == ''){
            this.$erpToastError('Senha obrigatoria')
            return
          }
          let obj = {}
          obj.senha = this.senha

          var modulo = 'cg/valida/adminpass/'
          const data = await apiORDSpost(this.$store, modulo, obj, 'post')
          if (!data.resultado) {
            this.$erpToastError('Senha invalida')
            return
          }

        }
        this.visible = false
        this.$emit('confirm')
      }
    }
  }
</script>

<template>
  <transition>
    <div class="modal nb-modal-mask" style="display: block">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="def-title" id="exampleModalLabel"> {{ vTitle }} </h4>
            <button type="button" class="close" @click="handleCloseButton()" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="max-height: 255px; overflow-y: auto">
            <div class="col-12">
              <span class=""> {{ vMessage }} </span>
            </div>
            <hr>
            <div v-if="adminPass">
              <input type="text" class="hidde-input">
            
              <form-field ref="senha" :hiddeLoginInformations="true" v-model="senha" type="password" col="6" label="Digite a senha de administrador" @key.enter="handleConfirmButton()">

              </form-field>
            </div>
          </div>
          <div class="modal-footer">
            <button v-if="btnConfirm" type="button" ref="btnConfirm" class="btn btn-sm" :class="btnClass" @click="handleConfirmButton()"> {{ btnConfirmText }} </button>
            <button v-if="btnCancel"  type="button" ref="btnClose" class="btn btn-sm" data-dismiss="modal" @click="handleCloseButton()"> {{ btnCancelText }} </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style>
.hidde-input{
  width:0; height:0; border:0; padding:0; 
}
</style>


// WEBPACK FOOTER //
// src/components/md-message.vue